export default "__VITE_ASSET__Ge8B9zKw__ 600w";